// Espelha backend/utils/executionProgress.js — mesma regra canônica de
// progresso usada em Execuções, Ciclos e Planos de Teste: bug, melhoria,
// bloqueado e retestar contam como progresso; só planejado, pendente e em
// andamento não contam. Antes Executions.js e CycleCasesModal.js mantinham
// cada um sua própria cópia dessa normalização (uma delas nem fazia
// lowercase antes de comparar, então um status como "Passed" capitalizado
// não batia com nenhuma chave e sumia da contagem sem aviso) — mantida num
// só lugar pra não desalinhar as telas de novo.

const PROGRESS_BAR_STATUS_MAP = {
  passed: 'completed',
  completed: 'completed',
  concluido: 'completed',
  concluida: 'completed',
  'concluída': 'completed',
  finalizado: 'completed',
  finalizada: 'completed',
  failed: 'bug',
  bug: 'bug',
  improvement: 'improvement',
  melhoria: 'improvement',
  warning: 'improvement',
  blocked: 'blocked',
  bloqueado: 'blocked',
  retest: 'retest',
  pending: 'pending',
  skipped: 'planned',
  planned: 'planned',
  running: 'running',
  active: 'running',
  in_progress: 'running',
  executando: 'running',
  'em andamento': 'running',
  em_andamento: 'running'
};

export function normalizeProgressBarStatus(raw) {
  const t = String(raw || '').trim().toLowerCase();
  return PROGRESS_BAR_STATUS_MAP[t] || 'planned';
}

export const PROGRESS_BAR_NOT_COUNTED = new Set(['planned', 'pending', 'running']);

// Conta um array de resultados (test_results, ou qualquer lista com um campo
// de status) nos baldes canônicos. `getStatus` deixa cada tela extrair o
// status de onde ele estiver (r.status, statusByCaseId[...].status, etc).
export function computeProgressCounts(results, getStatus = (r) => r?.status) {
  const arr = Array.isArray(results) ? results : [];
  const totals = { total: arr.length, completed: 0, bug: 0, improvement: 0, blocked: 0, retest: 0, pending: 0, planned: 0, running: 0 };
  arr.forEach(r => {
    const normalized = normalizeProgressBarStatus(getStatus(r));
    if (totals[normalized] !== undefined) totals[normalized] += 1;
  });
  const falseCompleted = totals.completed + totals.blocked;
  const notCounted = Array.from(PROGRESS_BAR_NOT_COUNTED).reduce((sum, k) => sum + totals[k], 0);
  const executed = totals.total - notCounted;
  const percentCompleted = totals.total ? Math.round((executed / totals.total) * 100) : 0;
  return { ...totals, falseCompleted, percentCompleted };
}
